import React, {Component} from 'react';
import {Col, Container, Row} from 'reactstrap';
import Skills from './components/Skills';
import Section from "./components/Section";
import Intro from './components/Intro';
import { DATE_IN_ROW, DATE_INLINE, SUBTITLE_LINK_INLINE, START_TO_END, END_DATE } from '../../Constants/Constants';
import { WHITE } from '../../Constants/Colors';
// import {data} from '../../store/data';

class FullPage extends Component {

	constructor(props) {
		super(props);
		this.state = {
			data: props.data
		}
	}

	//border: "5px solid #607d8b"
	styles = {
		paper: {
			padding: "0px 10px",
			margin: "10px 10px",
			border: "1px solid #311B92",
			borderRadius: "5px",
			color: "#311B92",
			backgroundColor: "#fff",
		},
		title: {
			fontWeight: 500,
		},
		designation: {
			fontWeight: 400,
			fontStyle: 'italic'
		},
		keyValue: {
			padding: "0",
			margin: "0"
		},
		sidebar: {
			padding: "1rem",
			borderTopRightRadius: "0",
			borderBottomRightRadius: "0",
			borderTopLeftRadius: "5px",
			borderBottomLeftRadius: "5px",
			// borderRadius: "5px",
			// backgroundColor: "#4527A0",
			// color: "#fff",
		},
		'rightSidebar': {
			padding: "1rem"
		},
		sidebarLink: {
			// color: "#E8F5E9"
		},
		link: {
			// color: "#7E57C2"
		},
		social_links: {
			// color: "#fff"
		},
		section: {
			padding: "0rem 1rem 1rem 1rem",
			// paddingBottom: "1rem",
			item: {
				paddingBottom: "1rem",
				fontSize: "1rem",
				fontWeight: 400,
				title: {fontWeight: 500, lineHeight: "1.5rem"},
				subTitle: {fontStyle: "italic"},
				description: {},
				duration: {fontWeight: 500},
			},
			timelineLight: {
				color: 'white',
				topBallColor: '#4527A0',
				topBallBorderColor: '#eceff1',
				bottomBallColor: 'white'
			},
			timelineDark: {
				color: '#bdbdbd',
				topBallColor: '#4527A0',
				topBallBorderColor: '#4527A0',
				bottomBallColor: '#bdbdbd'
			},
			intro: {
				padding: '1rem 1rem 0rem',
				margin: '1rem 0rem 0rem',
				// backgroundColor: "#311B92",
				// borderBottom: `2px solid ${accentColor}`
				// borderBottom: '2px solid #b71c1c'
			},
		},
		socialLinksContainer: {
			textAlign: 'right',
			// padding: "0px 10px"
		},
		contactsKeyValueContainer: {
			justifyContent: 'flex-end',
		}
	};

	render() {
		const data = this.state.data;
		let kvs = data.kvs;
		let social = data.social;
		let skills = data.skills;
		let education = data.education;
		let internships = data.internships;
		let projects = data.projects;
		let courses = data.courses;

		return (
			<Container style={{margin: "1rem auto"}}>
				<div style={this.styles.paper}>
					<Row>
						<Col>
							<Intro
									title={data.title}
									subtitle={data.subtitle}
									// showQR
									// qrcode="https://lalitjain98.github.io/my-resume"
									styles={this.styles}
									data={kvs}
									social={social}
									isFullPage
								/>
						</Col>
					</Row>
					<Row>
						<Col md={7} style={this.styles.sidebar}>
							<Section
								showTimeline
								styles={this.styles}
								title="Past Internships"
								data={internships}
								datePosition={DATE_IN_ROW}
								dateFormat={START_TO_END}
								showDescription={true}
								linkPosition={SUBTITLE_LINK_INLINE}
								linkStyles={this.styles.link}
								isSubtitleLink
								/>
							<Section
								showTimeline
								timelineDark
								styles={this.styles}
								title="Education"
								data={education}
								datePosition={DATE_IN_ROW}
								dateFormat={END_DATE}
								showDescription={true}
								linkStyles={this.styles.link}
								/>
							
						</Col>

						{/*fas fa-code */}
						<Col style={this.styles.rightSidebar}>
							
							<Section
								styles={this.styles}
								title="Projects"
								data={projects.filter(item=>item.isImportant)}								// linkPosition={SUBTITLE_LINK_INLINE}
								datePosition={DATE_INLINE}
								dateFormat={END_DATE}
								showDescription={true}
								linkPosition={SUBTITLE_LINK_INLINE}
								linkStyles={this.styles.link}
							/>
							<Section
								styles={this.styles}
								title="Courses and Certificates"
								data={courses}
								datePosition={DATE_INLINE}
								dateFormat={END_DATE}
								showDescription={true}
								linkStyles={this.styles.sidebarLink}
								timelineLight
								/>
							<Skills
								containerStyle={{paddingTop: "1rem"}}
								commaSeparated
								styles={this.styles}
								icon="fa fa-code"
								data={skills}
							/>
						</Col>
					</Row>
				</div>
			</Container>
		);
	}
}

export default FullPage;